import React from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";

export default function AIPerformanceChart({ daily, promptChanges = [] }) {
    const { t } = useTranslation();
    if (!daily?.length) return null;

    const maxTotal = Math.max(...daily.map((d) => d.total), 1);
    const promptDates = new Set(promptChanges.map((p) => p.createdAt?.split("T")[0]));

    return (
        <div>
            <h3 className="text-sm font-semibold mb-3">{t("admin.support.dailyBreakdown", "Daily Breakdown")}</h3>
            <div className="flex items-center gap-3 text-xs text-muted-foreground mb-2">
                <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-green-500 inline-block" /> {t("admin.support.accepted", "Accepted")}</span>
                <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-yellow-500 inline-block" /> {t("admin.support.edited", "Edited")}</span>
                <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-red-500 inline-block" /> {t("admin.support.denied", "Denied")}</span>
                <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-blue-500 inline-block" /> {t("admin.support.promptChange", "Prompt Change")}</span>
            </div>
            <div className="flex items-end gap-1" style={{ height: 160 }}>
                {daily.map((d) => {
                    const h = (d.total / maxTotal) * 140;
                    const accH = d.total > 0 ? (d.accepted / d.total) * h : 0;
                    const editH = d.total > 0 ? (d.edited / d.total) * h : 0;
                    const denyH = h - accH - editH;
                    const hasPromptChange = promptDates.has(d.date);
                    return (
                        <div key={d.date} className="flex-1 flex flex-col items-center gap-0.5" title={`${format(new Date(d.date), "MMM d")}: ${d.accepted}A/${d.edited}E/${d.denied}D`}>
                            {hasPromptChange && <div className="w-1.5 h-1.5 rounded-full bg-blue-500 mb-0.5" />}
                            <div className="w-full flex flex-col-reverse rounded-sm overflow-hidden" style={{ height: Math.max(h, 2) }}>
                                {accH > 0 && <div className="bg-green-500" style={{ height: accH }} />}
                                {editH > 0 && <div className="bg-yellow-500" style={{ height: editH }} />}
                                {denyH > 0 && <div className="bg-red-500" style={{ height: denyH }} />}
                            </div>
                            {daily.length <= 14 && <span className="text-[9px] text-muted-foreground mt-0.5">{format(new Date(d.date), "d")}</span>}
                        </div>
                    );
                })}
            </div>
            {daily.length > 14 && (
                <div className="flex justify-between text-[9px] text-muted-foreground mt-1">
                    <span>{format(new Date(daily[0].date), "MMM d")}</span>
                    <span>{format(new Date(daily[daily.length - 1].date), "MMM d")}</span>
                </div>
            )}
        </div>
    );
}
